<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-truncate">
        <div style="display: flex; align-items: center">
          <div>
            <a v-if="hasOpenDetailListener()" @click.stop="emitOpenDetail">
              {{ item.title }}
            </a>
            <span v-else> {{ item.title }} </span>
          </div>
          <v-spacer />
          <slot name="titleActions" />
        </div>
      </v-list-item-title>
      <v-list-item-subtitle v-if="!small">
        <div class="d-flex align-items-start">
          {{ item.timestamp.createdReadable }}
        </div>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import { IFleet } from "@/models/fleet.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";

@Component({
  components: {},
  filters: {}
})
export default class RefsFleet extends mixins(Vue) implements IRefDetail<IFleet> {
  @Prop()
  item!: IFleet;

  @Prop()
  small!: boolean;

  @Prop()
  confirmable!: boolean;

  hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.item);
  }

  async goToDetail() {
    const partnerId = this.item.partnerId;
    const fleetId = this.item.id;

    this.$router.push({ name: "FleetDetailView", params: { partnerId: partnerId, fleetId: fleetId } });
  }
}
</script>
<style lang="css" scoped>
.hoverCurserMouse :hover {
  cursor: pointer;
}

.align-items-start {
  align-items: flex-start;
}
</style>
